import { render } from "./VideoDetailView.vue?vue&type=template&id=671c7093"
import script from "./VideoDetailView.vue?vue&type=script&lang=js"
export * from "./VideoDetailView.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__